import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "./lib/useLenis";
import Header from "./components/Header";
import Footer from "./components/Footer";
import QuickActions from "./components/QuickActions";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import ChiSono from "./pages/ChiSono";
import Servizi from "./pages/Servizi";
import Prenota from "./pages/Prenota";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import ProtocolloTata from "./pages/ProtocolloTata";
import { Navigate } from "react-router-dom";
import MetodoTata from "./pages/MetodoTata";
import CuraDomicilio from "./pages/CuraDomicilio";
import Feste from "./pages/Feste";
import Academy from "./pages/Academy";
import Guida from "./pages/Guida";
import Risorse from "./pages/Risorse";
import DiconoDiMe from "./pages/DiconoDiMe";
import Podcast from "./pages/Podcast";
import Baule from "./pages/Baule";
import Voucher from "./pages/Voucher";
import AssistenzaNeonatale from "./pages/AssistenzaNeonatale";
import Privacy from "./pages/Privacy";
import CookiePolicy from "./pages/CookiePolicy";
import Terms from "./pages/Terms";
import NoteLegali from "./pages/NoteLegali";
import Faq from "./pages/Faq";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminResources from "./pages/AdminResources";
import AdminStats from "./pages/AdminStats";
import AdminResourcePreview from "./pages/AdminResourcePreview";
import AdminNewsletter from "./pages/AdminNewsletter";
import AdminMagazines from "./pages/AdminMagazines";
import AdminVouchers from "./pages/AdminVouchers";
import AdminRichieste from "./pages/AdminRichieste";
import RegalaCura from "./pages/RegalaCura";
import RegalaCuraAziende from "./pages/RegalaCuraAziende";
import Avvento from "./pages/Avvento";
import AvventoGiorno from "./pages/AvventoGiorno";
import AdminAvvento from "./pages/AdminAvvento";
import BecomeTataPro from "./pages/BecomeTataPro";
import Magazine from "./pages/Magazine";
import MagazineReader from "./pages/MagazineReader";

function AppShell({ children }) {
  useLenis();
  useEffect(() => {
    document.title = "Teresa Vilardo — Family Coach Montessori · Educatrice neonatale";
  }, []);
  return (
    <div className="App relative">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <main>{children}</main>
      <QuickActions />
      <CookieBanner />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        richColors
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#3D2140",
            border: "1px solid #81C3C9",
            borderRadius: "16px",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<AppShell><Home /></AppShell>} />
        <Route path="/chi-sono" element={<AppShell><ChiSono /></AppShell>} />
        <Route path="/cosa-posso-fare-per-te" element={<AppShell><Servizi /></AppShell>} />
        <Route path="/servizi" element={<Navigate to="/cosa-posso-fare-per-te" replace />} />
        <Route path="/cura-domicilio" element={<AppShell><CuraDomicilio /></AppShell>} />
        <Route path="/feste" element={<AppShell><Feste /></AppShell>} />
        <Route path="/academy" element={<AppShell><Academy /></AppShell>} />
        <Route path="/guida-gratuita" element={<AppShell><Guida /></AppShell>} />
        <Route path="/risorse" element={<AppShell><Risorse /></AppShell>} />
        <Route path="/dicono-di-me" element={<AppShell><DiconoDiMe /></AppShell>} />
        <Route path="/podcast" element={<AppShell><Podcast /></AppShell>} />
        <Route path="/magazine" element={<AppShell><Magazine /></AppShell>} />
        <Route path="/magazine/:slug" element={<MagazineReader />} />
        <Route path="/il-baule" element={<AppShell><Baule /></AppShell>} />
        <Route path="/voucher-regalo" element={<AppShell><Voucher /></AppShell>} />
        <Route path="/assistenza-neonatale" element={<AppShell><AssistenzaNeonatale /></AppShell>} />
        <Route path="/privacy" element={<AppShell><Privacy /></AppShell>} />
        <Route path="/cookie-policy" element={<AppShell><CookiePolicy /></AppShell>} />
        <Route path="/termini" element={<AppShell><Terms /></AppShell>} />
        <Route path="/note-legali" element={<AppShell><NoteLegali /></AppShell>} />
        <Route path="/faq" element={<AppShell><Faq /></AppShell>} />
        <Route path="/metodo-tata" element={<AppShell><MetodoTata /></AppShell>} />
        <Route path="/protocollo-tata" element={<Navigate to="/metodo-tata#protocollo" replace />} />
        <Route path="/prenota" element={<AppShell><Prenota /></AppShell>} />
        <Route path="/blog" element={<AppShell><Blog /></AppShell>} />
        <Route path="/blog/:slug" element={<AppShell><BlogPost /></AppShell>} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/risorse" element={<AdminResources />} />
        <Route path="/admin/risorse/anteprima/:id" element={<AdminResourcePreview />} />
        <Route path="/admin/statistiche" element={<AdminStats />} />
        <Route path="/admin/newsletter" element={<AdminNewsletter />} />
        <Route path="/admin/magazine" element={<AdminMagazines />} />
        <Route path="/admin/voucher" element={<AdminVouchers />} />
        <Route path="/admin/richieste-info" element={<AdminRichieste />} />
        <Route path="/regala-cura" element={<RegalaCura />} />
        <Route path="/regala-cura-aziende" element={<RegalaCuraAziende />} />
        <Route path="/calendario-avvento-2026" element={<AppShell><Avvento /></AppShell>} />
        <Route path="/become-tata-like-a-pro" element={<AppShell><BecomeTataPro /></AppShell>} />
        <Route path="/calendario-avvento-2026/:daySlug" element={<AppShell><AvventoGiorno /></AppShell>} />
        <Route path="/admin/avvento" element={<AdminAvvento />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
